export const TERM_MODEL_TYPE = {
    MD_THIET_BI: "dmthietbi",
}